import { IRootState } from '../../../store'
import { IFillablePDFOptionsState } from '../store/options.types'

export const getFillablePDFOptionsSelector = (state: IRootState): IFillablePDFOptionsState =>
  state.options.fillablePDFOptions
